import type { Observable } from 'ladda-observable';
import { useEffect } from 'react';
import type { LoadingValue } from './useLoadingValue';
import { useLoadingValue } from './useLoadingValue';

export const useObservable = <T>(fn: () => Observable<T>, dependencies?: any[]): LoadingValue<T> => {
    const { value, error, loading, setLoading, setValue, setError } = useLoadingValue<T>();

    useEffect(() => {
        if (!loading) {
            setLoading(true);
        }
        const { unsubscribe } = fn().subscribe(setValue, setError);
        return () => unsubscribe();
    }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps

    return { value, error, loading };
};
